// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import VueClipboard from 'vue-clipboard2'
import 'mint-ui/lib/style.css'
import VueJsonp from 'vue-jsonp'
import http from './api/http'
import { Picker } from 'mint-ui'
import { Popup } from 'mint-ui'
import * as utils from './utils'

Vue.use(VueJsonp)
Vue.use(Mint)
Vue.use(VueClipboard)
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)

Vue.config.productionTip = false
Vue.prototype.$http = http
// 全局api接口地址
Vue.prototype.GLOBAL = {
  // 正式
  // 'apiUrl': '//app.youquanyun.com',
  'apiUrl': 'http://shop.shikegou8.com',
  // 测试
  // 'apiUrl': '//unative.bangyaosoft.cn',
  // release 环境
  // 'apiUrl':'//release.youquanyun.com',
  'bizId': '392',
  'getQueryString': function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    }
    return null
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

window.onload = function () {
  getRem(750, 100)
}
window.onresize = function () {
  getRem(750, 100)
}
function getRem (pwidth, prem) {
  var html = document.getElementsByTagName('html')[0]
  var oWidth = document.body.clientWidth || document.documentElement.clientWidth
  html.style.fontSize = oWidth / pwidth * prem + 'px'
}
// 获取连接#后的字符
// function GetRequest () {
//   var str = location.href
//   var num = str.indexOf('#')
//   str = str.substr(num + 1)
//   return str
// }
if (utils.isWechatBrowser()) {
  // 微信浏览器中
  if (bizId !== null) {
    weixinInit()
  }  
} else {
  // 非微信浏览器中
  // window.apiready()
}
function weixinInit () {
// 获取jssdk
  http.post(bizId+'/wechat/auth/jssdk', {
    url: encodeURIComponent(location.href.split('#')[0])
  }, true).then(res => {
    console.log(res.data.data)
    wx.config({
      debug: res.data.data.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.data.signature, // 必填，签名
      jsApiList: res.data.data.jsApiList // 必填，需要使用的JS接口列表
    })
    wx.ready(() => {
      // getShareOption()
    })
    wx.error((res) => {
      console.log('微信配置失败：', res)
    })
  })
}


// WEBPACK FOOTER //
// ./src/main.js